import type { TOC } from '@ember/component/template-only';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import { didInsert } from '@ember/render-modifiers';
import { PrismButton, PrismCard } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import SettingsMyotbEligibilityQuestion from 'lumen/components/settings/myotb/eligibility-question';
import SettingsMyotbOtbSelfServiceDataBar from 'lumen/components/settings/myotb/otb-self-service-data-bar';
import type HotelSettingsMyotbPmsEligibilityController from 'lumen/controllers/hotel/settings/myotb/pms-eligibility';

interface HotelSettingsMyotbPmsEligibilitySignature {
  Args: {
    controller: HotelSettingsMyotbPmsEligibilityController;
    model: unknown;
  };
}

<template>
  <PrismCard @contentLayout="noPadding" class="myotb-card">
    <:content>
      <div
        class="myotb-card__content-container flex flex-col gap-400 p-400"
        {{didInsert @controller.setDefaults}}
      >
        <SettingsMyotbOtbSelfServiceDataBar />
        <div class="flex flex-col gap-800">
          {{#each @controller.eligibilityQuestions as |eligibilityQuestion|}}
            <SettingsMyotbEligibilityQuestion
              @answers={{eligibilityQuestion.answers}}
              @name={{eligibilityQuestion.name}}
              @options={{eligibilityQuestion.options}}
              @questionType={{eligibilityQuestion.questionType}}
              @setAnswers={{@controller.setAnswers}}
            />
          {{/each}}
        </div>
      </div>
    </:content>

    <:footer>
      <div class="flex justify-between gap-300">
        <PrismButton
          @buttonType="ghost"
          @iconBefore="arrow-left"
          @label={{t "general.back"}}
          @onClick={{@controller.onClickPrevious}}
        />
        <PrismButton
          @iconAfter="arrow-right"
          @isLoading={{@controller.isLoading}}
          @label={{t "general.continue"}}
          @onClick={{@controller.onClickContinue}}
        />
      </div>
    </:footer>
  </PrismCard>
</template> satisfies TOC<HotelSettingsMyotbPmsEligibilitySignature>;
